import React, { useEffect, useMemo, useState } from 'react';
import { colors } from '../../assets/colors/index.tsx';

export const CookiesBanner: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const styles = useMemo(() => ({
    container: {
      position: 'fixed' as const,
      left: '50%',
      bottom: 20,
      transform: 'translateX(-50%)',
      width: 'calc(100% - 2rem)',
      maxWidth: 960,
      background: colors.secondary,
      color: colors.quaternary,
      border: '1px solid rgba(0, 0, 0, 0.08)',
      borderRadius: 14,
      boxShadow: '0 18px 50px rgba(0,0,0,0.12)',
      padding: '1rem 1.25rem',
      zIndex: 1000,
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      gap: '1rem',
      flexWrap: 'wrap' as const,
    },
    textWrap: {
      display: 'flex',
      flexDirection: 'column' as const,
      gap: '0.25rem',
      minWidth: 260,
      flex: 1,
    },
    title: {
      fontWeight: 700,
      fontSize: '1rem',
      color: colors.quaternary,
    },
    description: {
      margin: 0,
      color: colors.tertiary,
      fontSize: '0.95rem',
      lineHeight: 1.4,
    },
    actions: {
      display: 'flex',
      gap: '0.75rem',
    },
    primaryBtn: {
      background: colors.primary,
      color: colors.quaternary,
      border: 'none',
      padding: '0.65rem 1rem',
      borderRadius: 10,
      fontSize: '0.95rem',
      fontWeight: 600,
      cursor: 'pointer',
    },
    secondaryBtn: {
      background: colors.secondary,
      color: colors.quaternary,
      border: '1px solid rgba(0, 0, 0, 0.1)',
      padding: '0.65rem 1rem',
      borderRadius: 10,
      fontSize: '0.95rem',
      fontWeight: 500,
      cursor: 'pointer',
    },
    link: {
      color: colors.primary,
      textDecoration: 'underline',
      cursor: 'pointer',
    },
  }), []);

  useEffect(() => {
    try {
      const consent = localStorage.getItem('cookiesConsent');
      if (!consent) {
        setIsVisible(true);
      }
    } catch (_err) {
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    try {
      localStorage.setItem('cookiesConsent', 'accepted');
    } catch (_err) {}
    setIsVisible(false);
  };

  const declineCookies = () => {
    try {
      localStorage.setItem('cookiesConsent', 'declined');
    } catch (_err) {}
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div role="dialog" aria-live="polite" aria-label="Cookie consent" style={styles.container}>
      <div style={styles.content}>
        <div style={styles.textWrap}>
          <div style={styles.title}>We value your privacy</div>
          <p style={styles.description as React.CSSProperties}>
            We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic.{' '}
          </p>
        </div>
        <div style={styles.actions}>
          <button onClick={declineCookies} style={styles.secondaryBtn}>Decline</button>
          <button onClick={acceptCookies} style={styles.primaryBtn}>Accept</button>
        </div>
      </div>
    </div>
  );
};

export default CookiesBanner;


